var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-scrolltop",attrs:{"id":"kt_scrolltop"}},[_c('i',{staticClass:"fa fa-arrow-up"})])}]

export { render, staticRenderFns }